module.exports = __webpack_public_path__ + "img/side_bookmark.8d546fb4.png";